export default __webpack_public_path__ + "media/src/usersite/images/footer/traveler-b4d632cd130ef69e18afd1b6d74ebfa4.png";